import { ReactComponent as sosAlert } from '../assets/icons/sosAlert.svg';
import { ReactComponent as sosAlertHoverLight } from '../assets/icons/sos-alert-hover-light.svg';
import { ReactComponent as crititcalAlert } from '../assets/icons/criticalAlert.svg';
import { ReactComponent as warningAlert } from '../assets/icons/majorAlert.svg';
import { ReactComponent as warningAlertLightHover } from '../assets/icons/major-alert-light-hover.svg';
import { ReactComponent as moderateAlert } from '../assets/icons/minorAlert.svg';
import { ReactComponent as crash } from '../assets/icons/crash.svg';
import { ReactComponent as argument } from '../assets/icons/argument.svg';
import { ReactComponent as towAssistance } from '../assets/icons/towAssistance.svg';
import { ReactComponent as touch } from '../assets/icons/touch.svg';
import { ReactComponent as ticket } from '../assets/icons/ticket.svg';
import { ReactComponent as driverDrowsiness } from '../assets/icons/driver-drowsiness-grey.svg';
import { ReactComponent as driverDrowsinessRed } from '../assets/icons/driver-drowsiness-icon.svg';
import { ReactComponent as driverDrowsinessRedLightHover } from '../assets/icons/driver-drowsiness-icon-hover-light.svg';
import { ReactComponent as doorOpen } from '../assets/icons/door-open-grey.svg';
import { ReactComponent as overSpeed } from '../assets/icons/overspeed-grey.svg';
import { ANOMALY_TYPE } from './constants';

const cardsData = [
  {
    key: 'sos',
    title: 'SOS Alerts',
    count: 0,
    headerIcon: sosAlert,
    headerIconHover: sosAlertHoverLight,
    incidents: [
      {
        key: 'manual',
        text: 'Manual Trigger',
        count: 0,
        icon: touch,
      },
      {
        key: 'manual_dashboard',
        text: 'Manual Tickets Created',
        count: 0,
        icon: ticket,
      },
    ],
    alertColor: '#FF2124',
  },
  {
    key: 'driver_drowsiness',
    title: ANOMALY_TYPE.DRIVER_ANOMALIES,
    count: 0,
    headerIcon: driverDrowsinessRed,
    headerIconHover: driverDrowsinessRedLightHover,
    incidents: [
      {
        key: 'dms_drowsy',
        text: 'Driver Drowsiness',
        count: 0,
        icon: driverDrowsiness,
      },
      {
        key: 'non_drowsy',
        text: 'Non Drowsy',
        count: 0,
        icon: crash,
      },
    ],
    alertColor: '#FF2124',
  },
  {
    key: ANOMALY_TYPE.MAJOR.toLowerCase(),
    title: ANOMALY_TYPE.MAJOR,
    count: 0,
    headerIcon: warningAlert,
    headerIconHover: warningAlertLightHover,
    incidents: [
      {
        key: 'rash_driving',
        text: 'Rash Driving',
        count: 0,
        icon: argument,
      },
    ],
    alertColor: '#EEC100',
  },
  {
    key: ANOMALY_TYPE.MINOR.toLowerCase(),
    title: ANOMALY_TYPE.MINOR,
    count: 0,
    headerIcon: moderateAlert,
    headerIconHover: moderateAlert,
    incidents: [
      {
        key: 'door_open',
        text: 'Door Open',
        count: 0,
        icon: doorOpen,
      },
      {
        key: 'overspeed',
        text: 'Over Speeding',
        count: 0,
        icon: overSpeed,
      },
    ],
    alertColor: 'var(--minor-anomaly-color, #419E98)',
  },
];

const sampleCardsData = [
  {
    key: 'sos',
    title: 'SOS Alerts',
    count: 20,
    headerIcon: sosAlert,
    incidents: [
      {
        key: 'incident-crash',
        text: 'Crash',
        count: 4,
        icon: crash,
      },
      {
        key: 'incident-argument',
        text: 'Argument',
        count: 7,
        icon: argument,
      },
      {
        key: 'incident-tow-assistance',
        text: 'Tow assistance',
        count: 2,
        icon: towAssistance,
      },
    ],
    alertColor: 'var(--critical-anomaly-color, #FF2124)',
  },
  {
    key: 'critical',
    title: 'Critical',
    count: 20,
    headerIcon: crititcalAlert,
    incidents: [
      {
        text: 'Crash',
        count: 4,
        icon: crash,
      },
      {
        text: 'Rash Driving',
        count: 7,
        icon: argument,
      },
      {
        text: 'Over Speeding',
        count: 2,
        icon: towAssistance,
      },
    ],
    alertColor: 'var(--critical-anomaly-color, #FF2124)',
  },
  {
    key: 'major',
    title: 'Major',
    count: 17,
    headerIcon: warningAlert,
    incidents: [
      {
        text: 'Crash',
        count: 4,
        icon: crash,
      },
      {
        text: 'Driver Drowsiness',
        count: 7,
        icon: argument,
      },
      {
        text: 'Over Speeding',
        count: 2,
        icon: towAssistance,
      },
    ],
    alertColor: 'var(--major-anomaly-color, #EEC100)',
  },
  {
    key: 'minor',
    title: 'Minor',
    count: 10,
    headerIcon: moderateAlert,
    incidents: [
      {
        text: 'Crash',
        count: 4,
        icon: crash,
      },
      {
        text: 'Driver Drowziness',
        count: 7,
        icon: argument,
      },
      {
        text: 'Over Speeding',
        count: 2,
        icon: towAssistance,
      },
    ],
    alertColor: 'var(--minor-anomaly-color, #419E98)',
  },
];

export { cardsData, sampleCardsData };
